import {Fragment} from 'react';
import {Container} from '@/components/container';

import {
    Toolbar,
    ToolbarActions,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle
} from '@/partials/toolbar';
import {PageNavbar} from '@/pages/account';

import {UserSettingsContent} from '.';
import {useLayout} from '@/providers';

const UserSettingsPage = () => {
    const {currentLayout} = useLayout();

    return (
        <Fragment>
            <PageNavbar/>
            <Container>
                <UserSettingsContent/>
            </Container>
        </Fragment>
    );
};

export {UserSettingsPage};
